export const EUROSTAR_COMPANY_CODE = '9F';
export const EUROSTAR_COMPANY_NAME = 'Eurostar';
export const AMTRAK_COMPANY_CODE = '2V';
export const AMTRAK_COMPANY_NAME = 'Amtrak';

export default function AtcFlightRecommendationService(
    atcFlightSegmentService,
    atcFlightGroupService,
) {
    'ngInject';

    Object.assign(this, {
        getFirstFlight,
        getLastFlight,
        getSelectedGroupsInRecommendation,
        doesOutwardDepartEqualInwardArrival,
        doesInwardDepartEqualOutwardArrival,
        getFlightSupplierId,
        getFlights,
        getOutwardGroup,
        getInwardGroup,
        airlineEquals,
        isRoundTrip,
        isOneWayTrip,
    });

    function getOutwardGroup(recommendation) {
        return recommendation.FlightGroups[0];
    }

    function getInwardGroup(recommendation) {
        return recommendation.FlightGroups[recommendation.FlightGroups.length - 1];
    }

    function getFirstFlight(recommendation, selectedFlights) {
        const segment = recommendation.FlightSegments[0];
        const group = atcFlightSegmentService.getSelectedGroup(selectedFlights, segment);
        return group.Flights[0];
    }

    function doesOutwardDepartEqualInwardArrival(selectedFlights, recommendation) {
        const {outwardSelectedGroup, inwardSelectedGroup} = getOutwardInwardSelectedGroups(selectedFlights, recommendation);

        const outwardFirstFlight = atcFlightGroupService.getFirstFlight(outwardSelectedGroup);
        const inwardLastFlight = atcFlightGroupService.getLastFlight(inwardSelectedGroup);

        return outwardFirstFlight.DepartureAirport === inwardLastFlight.ArrivalAirport;
    }

    function doesInwardDepartEqualOutwardArrival(selectedFlights, recommendation) {
        const {outwardSelectedGroup, inwardSelectedGroup} = getOutwardInwardSelectedGroups(selectedFlights, recommendation);

        const outwardLastFlight = atcFlightGroupService.getLastFlight(outwardSelectedGroup);
        const inwardFirstFlight = atcFlightGroupService.getFirstFlight(inwardSelectedGroup);

        return inwardFirstFlight.DepartureAirport === outwardLastFlight.ArrivalAirport;
    }

    function getLastFlight(recommendation, selectedFlights) {
        const segment = recommendation.FlightSegments[recommendation.FlightSegments.length - 1];
        const group = atcFlightSegmentService.getSelectedGroup(selectedFlights, segment);
        return group.Flights[group.Flights.length - 1];
    }

    function getSelectedGroupsInRecommendation(recommendation, selectedFlights) {
        return recommendation.FlightSegments.map((segment) =>
            atcFlightSegmentService.getSelectedGroup(selectedFlights, segment));
    }


    function airlineEquals(recommendation, code, name) {
        return recommendation.MarketingCompanyCode === code
            && recommendation.MarketingCompanyName === name
            || recommendation.MarketingAirlineCode === code
            && recommendation.MarketingAirlineName === name
            || recommendation.ValidatingAirlineCode === code
            && recommendation.ValidatingAirlineName === name;
    }

    function getFlightSupplierId(recommendation) {
        if (!recommendation) {
            return null;
        }
        return recommendation.Supplier
            || recommendation.ServiceOption && recommendation.ServiceOption.Id
            || null;
    }

    function getOutwardInwardSelectedGroups(selectedFlights, recommendation) {
        const outwardSegment = atcFlightSegmentService.getOutwardSegment(recommendation);
        const inwardSegment = atcFlightSegmentService.getReturnSegment(recommendation);

        const outwardSelectedGroup = atcFlightSegmentService.getSelectedGroup(selectedFlights, outwardSegment);
        const inwardSelectedGroup = atcFlightSegmentService.getSelectedGroup(selectedFlights, inwardSegment);

        return {outwardSelectedGroup, inwardSelectedGroup};
    }

    function getFlights(recommendation) {
        const groups = recommendation.FlightSegments
            ? recommendation.FlightSegments.reduce((acc, segment) => [...acc, ...segment.FlightGroups], [])
            : recommendation.FlightGroups;
        return groups.reduce((acc, group) => [...acc, ...group.Flights], []);
    }

    function isRoundTrip(recommendation) {
        return recommendation.FlightSegments.length === 2;
    }

    function isOneWayTrip(recommendation) {
        return recommendation.FlightSegments.length === 1;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/atc/atc-flights-view/flight-recommendation/flight-recommendation-service.js